export function loadAction() {
    $(window).on("load", function () {
        if($(".load-action").length) {
            $(".load-action").addClass("loaded");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/load-action.js